import assign from 'object-assign';
import { EventEmitter } from 'events';
import { isEqual } from 'lodash';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

import {
  mapOrderShipment,
} from '../helpers/order-shipments';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'ORDER_SHIPMENTS_CHANGED';
// Tell listeners if a request is in flight
const SHIPMENT_CREATE_EVENT = 'ORDER_SHIPMENT_CREATE';

let currentOrderId;
let shipments;
const shipmentsPaginationData = {};

const OrderShipmentsStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  emitShipmentCreation(type) {
    this.emit(SHIPMENT_CREATE_EVENT, type);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  addShipmentCreationListener(callback) {
    this.on(SHIPMENT_CREATE_EVENT, callback);
  },

  removeShipmentCreationListener(callback) {
    this.removeListener(SHIPMENT_CREATE_EVENT, callback);
  },

  onResetShipments() {
    currentOrderId = undefined;
    shipments = undefined;
  },

  onOrderShipmentsRequested(orderId) {
    if (currentOrderId !== orderId) {
      shipments = undefined;
    }
    currentOrderId = orderId;
  },

  onOrderShipmentsUpdated(response) {
    let updatedShipments = [];
    if (response.items) {
      updatedShipments = response.items;
      shipmentsPaginationData.pages = response.pages;
    } else {
      updatedShipments = response;
    }
    const mappedShipments = (updatedShipments || []).map(mapOrderShipment);
    if (!isEqual(shipments, mappedShipments)) {
      shipments = mappedShipments;
      this.emitChange();
    }
  },

  getOrderShipmentPaginationData() {
    return shipmentsPaginationData;
  },

  onDeliveryOrderGenerated(job) {
    if (!job) {
      return;
    }

    const index = shipments.findIndex(j => j._id === job._id);
    if (index === -1) {
      return;
    }

    const targetJob = mapOrderShipment(job);

    shipments = [
      ...shipments.slice(0, index),
      targetJob,
      ...shipments.slice(index + 1),
    ];
    this.emitChange();
  },

  getOrderShipments() {
    return shipments;
  },

  onCreateShipmentRequested(orderId) {
    this.emitShipmentCreation('REQUESTED');
  },

  onCreateShipmentSucceeded(results) {
    this.emitShipmentCreation('SUCCEEDED');
    const mappedShipments = (results || []).map(mapOrderShipment);
    shipments = shipments.concat(mappedShipments);
    this.emitChange();
  },

  onCreateShipmentFailed(error) {
    this.emitShipmentCreation('FAILED');
  },

});

OrderShipmentsStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const action = payload.action;
  switch (action.type) {
    case ActionTypes.FETCH_ORDER_SHIPMENTS_REQUEST:
      OrderShipmentsStore.onOrderShipmentsRequested(
        action.orderId,
        action.options,
      );
      break;
    case ActionTypes.FETCH_ORDER_SHIPMENTS_SUCCESS:
      OrderShipmentsStore.onOrderShipmentsUpdated(action.response);
      break;
    case ActionTypes.GENERATE_DELIVERY_ORDER_SUCCESS:
      OrderShipmentsStore.onDeliveryOrderGenerated(action.job);
      break;
    case ActionTypes.RESET_ORDER_SHIPMENTS:
      OrderShipmentsStore.onResetShipments();
      break;
    case ActionTypes.CREATE_SHIPMENT_FROM_ORDER_REQUEST:
      OrderShipmentsStore.onCreateShipmentRequested(action.orderId);
      break;
    case ActionTypes.CREATE_SHIPMENT_FROM_ORDER_SUCCESS:
      OrderShipmentsStore.onCreateShipmentSucceeded(action.results);
      break;
    case ActionTypes.CREATE_SHIPMENT_FROM_ORDER_FAIL:
      OrderShipmentsStore.onCreateShipmentFailed(action.error);
      break;

    default:
      break;
  }
});

export default OrderShipmentsStore;
